// Sticker and blob outlines, drawn in a 100 x 100 box and rounded to one
// decimal so the server and the browser always produce identical paths.

const round = (value: number): number => Math.round(value * 10) / 10

const radialPath = (radiusAt: (angle: number) => number, steps: number): string => {
    const points: string[] = []

    for (let index = 0; index < steps; index++) {
        const angle = (index / steps) * Math.PI * 2
        const radius = radiusAt(angle)
        const x = round(50 + radius * Math.cos(angle))
        const y = round(50 + radius * Math.sin(angle))

        points.push(`${index === 0 ? 'M' : 'L'}${x} ${y}`)
    }

    return `${points.join(' ')}Z`
}

const starPath = (spikes: number, outer: number, inner: number): string => {
    const steps = spikes * 2

    return radialPath((angle) => {
        const index = Math.round((angle / (Math.PI * 2)) * steps)
        return index % 2 === 0 ? outer : inner
    }, steps)
}

export const SHAPES = {
    flower: radialPath((angle) => 41 + 8 * Math.cos(angle * 8), 160),
    burst: starPath(20, 50, 41),
    blob: radialPath((angle) => 44 + 3.5 * Math.sin(angle * 3) + 2.5 * Math.cos(angle * 7), 120),
    cloud: radialPath((angle) => 42 + 8 * Math.abs(Math.cos(angle * 3)), 150),
    gear: radialPath((angle) => 44 + 5 * Math.tanh(4 * Math.sin(angle * 10)), 200)
} as const

export type BlobShape = keyof typeof SHAPES
